import React from 'react';

import classNames from 'classnames';
import moment from 'moment';

import { getPartialCancelLabel } from '../SplitShift/segmentUtils';

const formatTime = (time) => moment.utc(time).format('hh:mm A');

/**
 * Renders the date/time cell of a shift slot card. When a flex slot has been partially cancelled it
 * shows the effective (trimmed) time with a badge naming the trim, plus the original scheduled range
 * underneath. The original time is what the feed sorts on - the effective time is display only.
 * @param {object} slot - shift slot row from the facility shifts feed
 * @param {boolean} shouldShowRouteBadges - whether the card is showing flex/on-demand route colors
 * @returns {JSX.Element}
 */
const SlotScheduleCell = ({ slot, shouldShowRouteBadges }) => {
	const trimBadgeLabel = getPartialCancelLabel(slot);
	const isTrimmed = !!trimBadgeLabel;
	const effectiveStartTime = slot.split_adjusted_start_time || slot.raw_start_time;
	const effectiveEndTime = slot.split_adjusted_end_time || slot.raw_end_time;
	const originalRange = `${formatTime(slot.raw_start_time)} - ${formatTime(slot.raw_end_time)}`;

	return (
		<>
			{isTrimmed && <div className="slot__trim-badge">{trimBadgeLabel}</div>}
			<div
				className={classNames('row g-0 align-items-center slot__date', {
					[`slot__date__${slot.is_flex ? 'flex' : 'shiftmed'}`]: shouldShowRouteBadges && !!slot.caregiver_id
				})}
			>
				<div className="shift-day">
					<div>
						<b>{moment.utc(slot.raw_start_time).format('MMM Do')}</b>
					</div>
					<div>{slot.shift_day}</div>
				</div>
				<div className="shift-time">
					<div className="shift-time__row">
						<div className="shift-time__row__title">from</div>
						<div className="shift-time__row__content">{formatTime(effectiveStartTime)}</div>
					</div>
					<div className="shift-time__row">
						<div className="shift-time__row__title">to</div>
						<div className="shift-time__row__content">{formatTime(effectiveEndTime)}</div>
					</div>
				</div>
				{isTrimmed && (
					<div className="shift-time__original">
						<span className="shift-time__original__title">Original</span>
						<span className="shift-time__original__content">{originalRange}</span>
					</div>
				)}
			</div>
		</>
	);
};

export default SlotScheduleCell;
